module.exports = __webpack_public_path__ + "img/ups-cod-old.f092a1e9.png";